import React, { ReactElement, ReactNode } from "react";
import * as RUTooltip from "@radix-ui/react-tooltip";

/**
 * @deprecated
 */
export const Tooltip = (props: Props): ReactElement => {
  const {
    triggerNode,
    contentNode,
    providerProps,
    rootProps,
    contentProps,
    triggerProps,
    arrowProps,
  } = props;

  return (
    <RUTooltip.Provider {...providerProps}>
      <RUTooltip.Root {...rootProps}>
        <RUTooltip.Trigger {...triggerProps} asChild>
          {triggerNode}
        </RUTooltip.Trigger>
        <RUTooltip.Content {...contentProps}>
          <RUTooltip.Arrow {...arrowProps} />
          {contentNode}
        </RUTooltip.Content>
      </RUTooltip.Root>
    </RUTooltip.Provider>
  );
};

interface Props {
  triggerNode: ReactNode;
  contentNode: ReactNode;
  providerProps?: RUTooltip.TooltipProviderProps;
  rootProps?: RUTooltip.TooltipProps;
  triggerProps?: RUTooltip.TooltipTriggerProps;
  contentProps?: RUTooltip.TooltipContentProps;
  arrowProps?: RUTooltip.TooltipArrowProps;
}
